import { render, staticRenderFns } from "./ModifyHistory.vue?vue&type=template&id=5ae5a954"
import script from "./ModifyHistory.vue?vue&type=script&lang=js"
export * from "./ModifyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports